module.exports = __webpack_public_path__ + "static/colour-cor-094870d6362f9b55bf56d14ddea5fca8.png";